import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Skeleton, Space, Tooltip } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import CheckboxDesc from '../../../Layout/CheckboxDesc';
import ClientListItem from './ClientListItem';
import { notificationError } from '../../../../core/actions';
import BulkActions from './BulkActions';
import MultiClientTagManagerModalV2 from '../helpers/MultiClientTagManagerModalV2';
import { BulkAssignedAssociateModal } from './components/BulkAssignedAssociateModal';

const ListOfClients = props => {
  const [openTagManager, setOpenTagManager] = useState(false);
  const [openAssignAsctManager, setOpenAssignAsctManager] = useState(false);

  const [clientAll, setClientAll] = useState(false);

  const addAll = () => {
    const all = props.tableData.filter(item => !item.disabled).map(item => item?.id);
    if (all.length > 0) {
      if (!props.allTags && props.selected_client_list.length < all.length) {
        props.setAllTags(true);
        setClientAll(true);
        // setSelectAllDisplay(true);
        props.setSelectedClientList(all);
      } else {
        props.setAllTags(false);
        setClientAll(false);
        props.setSelectedClientList([]);
      }
    } else {
      notificationError('No clients to add');
    }
  };

  const incrementPage = () => {
    const newPage = props.page + 1;
    props.setPage(newPage);
  };

  useEffect(() => {
    if (clientAll) {
      const all = props.tableData.filter(item => !item.disabled).map(item => item?.id);
      if (all.length > 0) {
        props.setSelectedClientList(all);
      } else {
        notificationError('No clients to add');
      }
    }
  }, [props.tableData.length]);

  const checkClientAllValue = value => {
    if (!value) {
      setClientAll(false);
    } else {
      setClientAll(props.tableData.length === props.selected_client_list.length);
    }
  };

  const handleCloseBulkAssigned = useCallback(() => {
    setOpenAssignAsctManager(false);
    props.setSelectedClientList([]);
  }, []);

  return (
    <div>
      <div className="add-edit-wrap clientBulkActionAndAll">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CheckboxDesc checked={clientAll} onclick={addAll} classProps="fs-13" checkButtonProps="m-btm-15 w-85" />
          <label style={{ marginLeft: 8, paddingBottom: 15 }}>Select All</label>
        </div>
        {props.selected_client_list.length > 0 && (
          <BulkActions
            auth={props.auth}
            setOpenTagManager={setOpenTagManager}
            setOpenAssignAsctManager={setOpenAssignAsctManager}
          />
        )}
      </div>
      <div
        id="scrollableDivChat"
        className={props.paymentBanner ? 'scrollableDivChatWithBanner' : 'scrollableDivChatNoBanner'}
        style={{
          overflow: 'auto',
        }}
      >
        {!props.isFetching && props.tableData.length === 0 ? (
          <div className="color-bdbdbd fs-12 fw-400 m-top-25">
            <span>{`No clients found ${props.search.length > 0 ? `for "${props.search}"` : ''}`}</span>
          </div>
        ) : (
          <InfiniteScroll
            dataLength={props.tableData.length}
            next={incrementPage}
            hasMore={props.isThereMoreClient}
            loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
            endMessage={<h4 style={{ margin: '12px 16px', paddingBottom: '40px' }}>No more clients</h4>}
            scrollableTarget="scrollableDivChat"
            pullDownToRefreshThreshold={50}
          >
            <ul className="ul-no-style" style={{ marginBottom: '40px' }}>
              {props.tableData?.map((msg, idx) => (
                <ClientListItem
                  key={`client_${msg.id}`}
                  getClientData={props.getClientData}
                  setCheckedClient={props.setCheckedClient}
                  checkedClient={props.checkedClient}
                  msg={msg}
                  idx={idx}
                  selected_client_list={props.selected_client_list}
                  listAdder={props.listAdder}
                  checkClintAllValue={checkClientAllValue}
                  selectedClientId={props.client?.client_id}
                />
              ))}
            </ul>
          </InfiniteScroll>
        )}
      </div>
      {openTagManager && (
        <MultiClientTagManagerModalV2
          showTagManagerHandler={setOpenTagManager}
          client={props.client}
          pagination={props.pagination}
          auth={props.auth}
          getClientData={props.getClientData}
        />
      )}
      <BulkAssignedAssociateModal
        open={openAssignAsctManager}
        onClose={handleCloseBulkAssigned}
        auth={props.auth}
        selected_client_list={props.client.selected_client_list}
        clientList={props.tableData}
        setTableData={props.setTableData}
        client={props.client}
      />
    </div>
  );
};

export default ListOfClients;
